// Basis-URL des License-Portal-Backends (Hono).
//
// Default = LEER = **same-origin/relativ**: im Prod served das Portal das gebaute SPA
// selbst (E1, `PORTAL_UI_DIST`) → die API liegt auf demselben Origin, relative Pfade
// (`/auth/login` etc.) treffen sie ohne CORS.
//
// Im Dev laeuft die SPA auf einem eigenen Vite-Port (5273) getrennt vom Portal → dann
// `VITE_PORTAL_URL=http://127.0.0.1:3177` (o.ae.) setzen (+ Portal-CORS). Siehe .env.example.
export const PORTAL_URL: string = import.meta.env.VITE_PORTAL_URL ?? "";
